module.exports = {
	createZoomButton: function(chart) {
		chart.zoomOutButton.background.defaultState.properties.fill = window.am4core.color('#0071b9');
		chart.zoomOutButton.background.defaultState.properties.fillOpacity = 0.9;
		chart.zoomOutButton.background.states.getKey('hover').properties.fill = window.am4core.color('#000');
	}
};
